import styled from 'styled-components';

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  font-family: 'Share Tech Mono', monospace;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.5);
`;

export const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 16px;
`;

export const Title = styled.div`
  font-family: 'Share Tech Mono', monospace;
  font-size: 15px;
  letter-spacing: 2px;
  color: rgba(255, 255, 255, 0.8);
  text-transform: uppercase;
`;

export const HeaderButtons = styled.div`
  margin: -2px 32px -2px 0px;
  display: flex;
  align-items: center;
`;

export const Amounts = styled.div`
  display: flex;
  align-items: center;
  padding: 12px 0;
  gap: 8px;
  flex-wrap: wrap;
`;

export const Amount = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.8);
`;

export const AmountsArrow = styled.div`
  color: rgba(255, 255, 255, 0.4);
`;

export const DividerLine = styled.div`
  width: 100%;
  height: 1px;
  background: rgba(155, 89, 182, 0.2);
`;

export const RoutingWrapper = styled.div`
  flex: 1;
  overflow: auto;
  padding: 16px 0;
  text-align: center;

  &::-webkit-scrollbar {
    width: 4px;
    height: 4px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background: rgba(155, 89, 182, 0.3);
    border-radius: 2px;
  }
`;

export const Routing = styled.div`
  display: inline-flex;
  align-items: center;
`;

export const RoutingLine = styled.div`
  margin: 0 8px;
  width: 1px;
  align-self: stretch;
  flex-shrink: 0;
  background: linear-gradient(transparent, rgba(155, 89, 182, 0.5), transparent);
`;

export const RouteArrow = styled.div`
  flex-shrink: 0;
  align-self: center;
  display: flex;
  align-items: center;
  color: rgba(255, 255, 255, 0.4);
  font-size: 15px;
`;

export const RoutePercent = styled.div`
  padding-left: 2px;
  transform: rotate(180deg);
  writing-mode: vertical-rl;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.4);
`;

export const RouteItem = styled.div`
  margin: 4px 6px;
  padding: 8px;
  align-self: stretch;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  border: 1px solid rgba(155, 89, 182, 0.2);
  background: rgba(155, 89, 182, 0.05);
`;

export const RouteItemToken = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 6px;
  gap: 6px;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.8);

  a {
    font-size: 13px;
    color: rgba(255, 255, 255, 0.5);
    transition: 0.15s;

    &:hover {
      color: rgba(255, 255, 255, 0.9);
    }
  }
`;

export const Dexes = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Dex = styled.div`
  flex-grow: 1;
  padding: 4px 6px;
  margin-bottom: 4px;
  border-radius: 6px;
  background: rgba(52, 152, 219, 0.1);
  font-size: 13px;
  color: rgba(255, 255, 255, 0.5);

  &:last-child {
    margin-bottom: 0;
  }
`;

export const RouteRow = styled.div`
  display: flex;
`;

export const RouteColumn = styled.div`
  display: flex;
  flex-direction: column;
`;
